import {
  refreshUser,
  initUserStore,
  startTokenRefreshScheduler,
  stopTokenRefreshScheduler,
} from '@tshared/stores/user.store'
import { useEffect, useState } from 'react'

import App from '@/containers/App.tsx'

export default function Root() {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    let mounted = true

    void initUserStore()
      .then(() => refreshUser())
      .finally(() => {
        if (!mounted) return

        startTokenRefreshScheduler()
        setReady(true)
      })

    return () => {
      mounted = false
      stopTokenRefreshScheduler()
    }
  }, [])

  if (!ready) return null

  return <App />
}
